<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>设置</h1>
        <span class="pull-right icon-right orange" @click="updateTeacher()">保存</span>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page class-edit">
      <div>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix group-txt upload-pic" style="height:60px;line-height:60px">
              <form class="clearfix" enctype="multipart/form-data" method="post" name="fileinfo">
                <span class="pull-left">设置头像：</span>
                <div class="pull-right img-wrap big" style="z-index:1"><img :src="imageAddress ? baseAcessPath + imageAddress : img_default"></div>
                <span class="upload-wrap" @click="capturePhoto();" v-if="isAndroid"></span>
                <span class="upload-wrap" v-else><input type="file" name="pic" id="pic" accept="image/*" size="1" @change="updateImage()"/></span>
              </form>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix group-txt">
              <span class="pull-left">姓名：</span>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="您的真实姓名" v-model="teacherName"/></span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <router-link class="clearfix group-txt img-more" :to="{'path': '/user/center/updPhone'}">
              <span class="pull-left">手机号码：</span>
              <span class="pull-right gray margin-x-15 font-14">{{phoneNum}}</span>
            </router-link>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <router-link class="clearfix  group-txt img-more" :to="{'path': '/user/center/about'}">
              <span class="pull-left">关于少儿之家：</span>
              <span class="pull-right gray  margin-x-15">园点端 v2.0</span>
            </router-link>
          </li>
        </ul>

        <ul class="list-group-item tinny">
          <li class="list-group">
            <a class="group-txt" @click.prevent="reload()"><span class="block text-center">清除缓存</span></a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="popupvisebleSetting = true"><span class="block text-center">退出登录</span></a>
          </li>
        </ul>
      </div>
    </div>

      <mt-popup
      v-model="popupvisebleSetting"
      position="bottom"
      >
      <div class="text-center">
        <ul class="list-group-item  tinny">
          <li class="list-group">
            <p class="gray padding-15">退出登录后不会删除任何历史数据，下次登录依然可以使用本账号</p>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="logout()"><span class="orange block font-16">退出</span></a>
          </li>
        </ul>
        <ul class="list-group-item tinny" style="margin:0">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="popupvisebleSetting = false"><span class="block font-16">取消</span></a>
          </li>
        </ul>
      </div>
      </mt-popup>
  </div>
</template>

<script>
import { service, uploadUrl } from '../../../service'
import { Toast, Indicator } from 'mint-ui'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      img_default: require('../../../assets/images/img-default.png'),
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      update_teacher_para: service.setPara('updateTeacher'),
      imageAddress: '',
      baseAcessPath: '',
      phoneNum: '',
      isHideLogout: true,
      teacherName: '',
      popupvisebleSetting: false,
      isAndroid: true
    }
  },
  mounted: function () {
    let b = window.browser()
    this.isAndroid = b.android

    this.phoneNum = this.cookie_login_data.phoneNum
    this.imageAddress = this.cookie_login_data.teacherIcon
    this.baseAcessPath = this.cookie_login_data.baseAcessPath
    if (this.login_data.length > 0) {
      this.teacherName = this.login_data[this.cookie_login_data.index].teacherName
      this.update_teacher_para.baseAcessPath = this.baseAcessPath
      this.update_teacher_para.teacherIcon = this.imageAddress
    }
  },
  methods: {
    ...mapMutations([
      'clearTeachers',
      'clearMine'
    ]),
    updateTeacher: function () {
      let that = this
      // that.update_teacher_para.baseAcessPath = response.data.data.baseAcessPath
      // that.update_teacher_para.teacherIcon = response.data.data.thumbFilePath
      if ($.trim(this.teacherName) == '') {
        Toast('请填写姓名')
        return
      }
      that.update_teacher_para.teacherId = that.cookie_login_data.teacherId
      that.update_teacher_para.curcheId = that.cookie_login_data.curcheId
      that.update_teacher_para.teacherName = that.teacherName
      Indicator.open('提交中...')

      let obj = {context: this, para: this.update_teacher_para, successFun: (response) => {
        Indicator.close()
        Toast('修改成功')
        that.imageAddress = that.update_teacher_para.teacherIcon
        that.baseAcessPath = that.update_teacher_para.baseAcessPath
        that.cookie_login_data.baseAcessPath = that.baseAcessPath
        that.cookie_login_data.teacherIcon = that.imageAddress
        // $.cookie('login_data', JSON.stringify(that.cookie_login_data), { expires: 7, path: '/' })
        window.localStorage['basic_login_data'] = JSON.stringify(that.cookie_login_data)

        if (that.login_data.length > 0) {
          that.login_data[that.cookie_login_data.index].baseAcessPath = that.baseAcessPath
          that.login_data[that.cookie_login_data.index].teacherIcon = that.imageAddress
          that.login_data[that.cookie_login_data.index].teacherName = that.teacherName
          window.localStorage['login_data'] = JSON.stringify(that.login_data)
        }
        this.$store.dispatch('clearMine')
        this.$store.dispatch('clearTeachers')
      }}
      service.request(obj)
    },
    updateImage: function () {
      var that = this
      if (document.getElementById('pic').files.length === 0) {
        return
      }

      lrz(document.getElementById('pic').files[0], {width: 100})
        .then(function (rst) {
          var data = new window.FormData()
          data.append('pic', rst.file, rst.origin.name)
          let url = uploadUrl + that.cookie_login_data.phoneNum + '&needThumb=1'
          let obj = {context: that, para: data, url: url, successFun: (response) => {
            that.update_teacher_para.baseAcessPath = response.data.baseAcessPath
            that.update_teacher_para.teacherIcon = response.data.thumbFilePath
            that.imageAddress = that.update_teacher_para.teacherIcon
            that.baseAcessPath = that.update_teacher_para.baseAcessPath
            this.$store.dispatch('clearMine')
            this.$store.dispatch('clearTeachers')
          }}
          service.request(obj)
        })
    },
    logout: function () {
      // $.removeCookie('login_data', { path: '/' })
      // window.localStorage['basic_login_data'] = '[]'
      // window.localStorage['login_data'] = '[]'
      window.localStorage.clear()
      this.$router.push('/signin')
    },
    reload: function () {
      // alert('i am coming')
      window.location.reload()
      // window.plugins.imagePicker.getPictures(
      //   function (results) {
      //     for (var i = 0; i < results.length; i++) {
      //       console.log('Image URI: ' + results[i])
      //     }
      //     $('#sfsfsf').attr('src', results[0])
      //   }, function (error) {
      //   console.log('Error: ' + error)
      // })

      // navigator.camera.getPicture(onSuccess, onFail, { quality: 1 })

      // function onSuccess (imageData) {
      //   var image = document.getElementById('sfsfsf')
      //   image.src = 'data:image/jpeg;base64,' + imageData
      // }

      // function onFail (message) {
      //   alert('Failed because: ' + message)
      // }
    },
    capturePhoto: function () {
      Indicator.open()
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, { quality: 80, destinationType: navigator.camera.DestinationType.DATA_URL, sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY, targetWidth: 200, targetHeight: 200 })
    },
    onPhotoDataSuccess: function (imageData) {
      let imgData = 'data:image/jpeg;base64,' + imageData
      let f = {}
      f.file = this.dataURLtoBlob(imgData)
      f.name = '0.png'

      var data = new window.FormData()
      data.append('pic', f.file, f.name)
      let url = uploadUrl + this.cookie_login_data.phoneNum + '&needThumb=1'
      let obj = {context: this, para: data, url: url, successFun: (response) => {
        this.update_teacher_para.baseAcessPath = response.data.baseAcessPath
        this.update_teacher_para.teacherIcon = response.data.thumbFilePath
        this.imageAddress = this.update_teacher_para.teacherIcon
        this.baseAcessPath = this.update_teacher_para.baseAcessPath
        Indicator.close()
      }}
      service.request(obj)
    },
    onFail: function (message) {
      Indicator.close()
      // alert('Failed because: ' + message)
    },
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = window.atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new window.Blob([u8arr], {type: mime})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-popup{background:none;}
</style>



// WEBPACK FOOTER //
// Settings.vue?97c4fb4e